<div class="flex flex-row h-16 w-full">
    <div class="flex h-full w-15 items-center justify-center">
        <button (click)="toggleLeftPanel()" aria-label="Show song order" class="">
            open/close
        </button>
    </div>
    <div class="flex h-full grow items-center justify-end">
        Auto Move
    </div>
    <div class="flex h-full items-center justify-center w-15">
        <button  aria-label="User icon" class="">
            more_vert
        </button>
    </div>
    <div class="bg-white w-70">
        <section class="">
            <button disabled="">
                save
                <span>Save (Auto)</span>
            </button>
            <button (click)="reset()">
                replay
                <span>Reset Rankings</span>
            </button>
        </section>
    </div>
</div>
<app-sliding-two-column-layout #slidingTwoColumnLayout>
    <div id="left-column" class="w-full">
        <app-production-game-rate></app-production-game-rate>
    </div>
    <div id="right-column" class="w-full">
        <app-production-game-rank #ranking></app-production-game-rank>
    </div>
</app-sliding-two-column-layout>
